export default "__VITE_ASSET__DtPIx8Gj__"